import { jsx } from "panel";
import { Placement } from "common/components/tooltip/types";
import { ButtonEl } from "common/components/button";
import { SpinnerEl } from "common/components/spinner";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { ButtonType } from "../button/constants";
export function template() {
  const {
    helpers
  } = this;
  const icon = this.attr("icon");
  const iconEl = icon ? /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon
  } }) : "";
  const uploadButton = /* @__PURE__ */ jsx("label", null, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: this.attr("button-theme"),
    icon,
    tabindex: 0,
    disabled: this.attr("disabled"),
    "style-override": this.attr("style-override")
  }, hook: {
    insert: helpers.uploadButtonInserted,
    destroy: helpers.uploadButtonDestroyed
  }, style: this.attr("button-styling") }, this.attr("label"), /* @__PURE__ */ jsx("input", { sel: ".upload-block-input", attrs: {
    type: "file",
    accept: this.attr("accept"),
    disabled: this.attr("disabled")
  }, on: {
    change: helpers.handleChange
  } })));
  const processing = /* @__PURE__ */ jsx("div", { sel: ".upload-processing" }, /* @__PURE__ */ jsx(SpinnerEl, null), " ", this.attr("processing-description"));
  const complete = /* @__PURE__ */ jsx("div", { sel: ".upload-complete" }, /* @__PURE__ */ jsx("div", { sel: ".filename", class: {
    "is-disabled": this.attr("disabled")
  } }, iconEl, helpers.getFileLabel(), helpers.getFileTooltip() ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Bottom,
    offset: 0,
    delay: 200
  } }, helpers.getFileTooltip()) : null), this.attr("enable-delete") ? /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: this.attr("button-theme"),
    type: ButtonType.Destructive,
    icon: "trashcan",
    tabindex: 0,
    disabled: this.attr("disabled")
  }, on: {
    click: helpers.handleDelete
  }, hook: {
    insert: helpers.deleteButtonInserted,
    destroy: helpers.deleteButtonDestroyed
  } }) : null);
  const shown = this.attr("completed-filename") ? complete : this.attr("processing-description") ? processing : uploadButton;
  return /* @__PURE__ */ jsx("div", { sel: ".file-upload-block", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, shown);
}
